module.exports = __webpack_public_path__ + "img/Single Neutral.7d913df1.svg";